.dropdownPaper:global(.MuiPopover-paper) {
	border: 1px solid #d4d4d4;
	border-radius: 10px;
	box-shadow: 0px 0px 20px 0px #00000026;
	gap: 0.25rem;
	padding: 0.5rem 0.5rem 0.25rem 0.75rem;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	max-height: 250px;
	overflow: hidden;
}

.listTitle {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 0.125rem;

	& :global(.MuiTypography-root) {
		color: #333333;
		font-size: 0.75rem;
		line-height: 1.6;
		font-weight: 600;
	}
}

.expandButton:global(.MuiButton-root),
.expandButton {
	border-radius: 4px;
	padding: 0;

	&.expanded {
		background-color: #e6e6e6;
	}
}

.expandButton:global(.MuiButton-root) {
	align-items: center;
	justify-content: flex-start;
	min-width: 0;
	max-width: 100%;
	text-align: left;

	& :global(.MuiButton-endIcon) {
		margin-left: 0;
		margin-right: 0;
	}

	&:hover {
		background-color: #ececec;
	}

	&.open {
		background-color: #e6e6e6;
	}
}
